import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `AddDialogFieldDirective` represent a add dialog fields of the react Gantt.
 * It must be contained in a Gantt component(`GanttComponent`).
 * ```tsx
 * <GanttComponent dataSource={data} allowSelection={true} allowSorting={true}>
 * <AddDialogFieldsDirective>
 * <AddDialogFieldDirective type='General' headerText='General'></AddDialogFieldDirective>
 * <AddDialogFieldDirective type='Dependency' headerText='Dependency'></AddDialogFieldDirective>
 * </AddDialogFieldsDirective>
 * </GanttComponent>
 * ```
 */
export class AddDialogFieldDirective extends ComplexBase {
}
AddDialogFieldDirective.moduleName = 'addDialogField';
export class AddDialogFieldsDirective extends ComplexBase {
}
AddDialogFieldsDirective.propertyName = 'addDialogFields';
AddDialogFieldsDirective.moduleName = 'addDialogFields';
